import Layout from '../common/Layout/Layout'
import React from 'react'

// DEBUG: Check each route
const childRoutes = [
  require('./home').default,
  require('./error').default,
  require('./search-results').default,
  require('./contact-an-adviser').default,
  require('./adviser-profile-view').default,
  require('./adviser-profile-edit').default,
  require('./rate-an-adviser').default,
  require('./verifyEmailAddress').default,
  require('./administrators').default,
  require('./administratorAdd').default,
  require('./adviserProfileWhitelist').default,
  require('./adviser-add').default,
  require('./adviser-profiles-pending-approval').default,
  require('./administrationLogin').default,
  require('./administrationUnauthorised').default,
  require('./mobile-not-supported').default,
  require('./administrationResetPassword').default,
  require('./resetPassword').default,
  require('./adviserDataDump').default,
  require('./advisers').default,
  require('./check').default,
  require('./adviser-profile-edit-find-an-ifa').default,
  require('./configureRateLimiter').default,
  require('./faifa').default,
  require('./notFound').default
]

// DEBUG: Log any invalid routes
childRoutes.forEach((route, index) => {
  if (!route || typeof route.path === 'undefined') {
    console.error(`Route at index ${index} is invalid:`, route)
  }
})

export default {
  path: '/',  // ← ADD THIS BACK for v8
  
  // Keep in mind, routes are evaluated in order
  children: childRoutes,

  async action ({ next }) {
    // Execute each child route until one of them return the result
    const route = await next()

    if (route) {
      route.title = route.title || 'Untitled Page'
      route.description = route.description || ''
      return route
    }
    return require('./notFound').default.action()
  }
}
